const getFullname = ({ firstname, lastname, fallback = 'Unknown user' }) => {
	if (!firstname && !lastname) {
		return fallback;
	}

	if (firstname && lastname) {
		return `${firstname} ${lastname}`;
	}

	return firstname || lastname;
};

export default getFullname;
